import { NAVEGAR_BREADCRUMB } from "./actionTypes"


export const navegarBreadCrumb = heap => {
  return {
    type: NAVEGAR_BREADCRUMB,
    payload: { heap }
  }
}
